var _rect, _rect2, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPowerHover(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 32,
    height: 32,
    rx: 6,
    fill: "#E7EAFF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 33,
    height: 33,
    rx: 6.5,
    stroke: "#314DDF",
    strokeOpacity: 0.3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M14 12.2V21.79C14 25 16 27 19.2 27H21.79C24.99 27 26.99 25 26.99 21.8V12.2C27 9 25 7 21.8 7H19.2C16 7 14 9 14 12.2Z",
    fill: "#314DDF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.43 13.1195L20.78 16.4695C21.07 16.7595 21.07 17.2395 20.78 17.5295L17.43 20.8795C17.14 21.1695 16.66 21.1695 16.37 20.8795C16.08 20.5895 16.08 20.1095 16.37 19.8195L18.44 17.7495H7.75C7.34 17.7495 7 17.4095 7 16.9995C7 16.5895 7.34 16.2495 7.75 16.2495H18.44L16.37 14.1795C16.22 14.0295 16.15 13.8395 16.15 13.6495C16.15 13.4595 16.22 13.2695 16.37 13.1195C16.66 12.8195 17.13 12.8195 17.43 13.1195Z",
    fill: "#314DDF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPowerHover);
export default __webpack_public_path__ + "static/media/power-hover.9d04b25062ce9e39b821ffa6715b50f1.svg";
export { ForwardRef as ReactComponent };